import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@eo/shared';

import type { UndoInProgressDialogProps } from './types';

// Undoing archives the ClickUp task; once someone is working on it that hides
// their work, so the CFO decides with that in front of them.
export function UndoInProgressDialog({
  taskName,
  message,
  busy,
  onCancel,
  onConfirm,
}: UndoInProgressDialogProps) {
  return (
    <Dialog
      open
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Undo “{taskName}”?</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={busy}>
            Revert anyway
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
